import React, { useState, useEffect } from 'react';
import { Row, Container, Col } from "react-bootstrap";
import { Button, IconButton, Dialog, DialogContent } from '@material-ui/core';
import AccessibiltyPolicy from '../Disclosure/AccessibilityPolicy';
import PrivacyPolicy from '../Disclosure/PrivacyPolicy';
import TermsAndConditions from '../Disclosure/TermsAndConditions';
import StateDisclosure from '../Disclosure/StateDisclosure';
import ContactUs from '../Contact/ContactUs';
import CloseIcon from '@material-ui/icons/Close';
import { getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY } from '../../sessionStorage';

import './Footer.scss';

const links = {
  Terms: "TermsAndConditions",
  Security: "SecurityAndPrivacyPolicy",
  Accessibilty: "AccessibiltyPolicy",
  Contact: "ContactUs",
  StateLicense: "StateLicenseDisclosure",
}

export default function Footer({expanded}) {
  const year = new Date().getFullYear();
  let aflac = document.location.pathname.toLowerCase().indexOf('supplemental') > -1;
  const isLandingPage = document.location.pathname.toLowerCase().indexOf('landing') > -1;

  const [infoDialogOpen, setInfoDialogOpen] = useState(false);
  const [accountId, setAccountId] = useState('');
  const [disclaimer, setDisclaimer] = useState('');
  const [disclaimerBelow, setDisclaimerBelow] = useState(false);
  const [renderComponent, setRenderComponent] = useState(null);

  useEffect(() => {
    var accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
    if (accountObj && accountObj.account && accountObj.account.accountId) {
      setAccountId(accountObj.account.accountId);
      setDisclaimer(accountObj.account.disclaimerHtml);
      setDisclaimerBelow(accountObj.account.customDisclaimerBelow);
    }
  }, []);

  const onButtonClick = (linkName) => {
    if (linkName === links.Terms) {
      setRenderComponent(<TermsAndConditions></TermsAndConditions>);
    } else if (linkName === links.Security) {
      setRenderComponent(<PrivacyPolicy></PrivacyPolicy>);
    } else if (linkName === links.AccessibiltyPolicy) {
      setRenderComponent(<AccessibiltyPolicy></AccessibiltyPolicy>);
    } else if (linkName === links.StateLicense) {
      setRenderComponent(<StateDisclosure></StateDisclosure>);
    } else if (linkName === links.Contact) {
      setRenderComponent(<ContactUs></ContactUs>);
    }
    setInfoDialogOpen(true);
  }

  const getDisclaimers = () => {
    return (
      <small>
        { disclaimerBelow &&
          <span>
            {aflac && aflacDisclaimer()}
            {covrDisclaimer()}
            <br />
          </span>
        }
        {!isLandingPage && disclaimer && <span>
          <span dangerouslySetInnerHTML={{ __html: disclaimer }} />
          <br />
        </span>}
        { !disclaimerBelow &&
          <span>
            {aflac && aflacDisclaimer()}
            {covrDisclaimer()}
          </span>}
      </small>
    )
  }

  const aflacDisclaimer = () => {
    return (
      <span>
        <span>IMPORTANT NOTICES APPLICABLE TO AFLAC:</span><br />
        <span>Coverage is underwritten by Aflac. In New York, Aflac New York.</span><br />
        <span>The information provided is a brief product overview only. Coverage may not be available in all states, including New York. Policies have
        limitations and exclusions that may affect benefits payable. Refer to the polices for complete benefit details, limitation, and exclusions.</span><br />
        <span>WWHQ | 1932 Wynnton Road | Columbus, GA 31999</span><br />
        <Row>
          <Col>form #Z200513B</Col>
          <Col> Exp. 8 / 21</Col>
        </Row>
      </span >
    )
  }

  const covrDisclaimer = () => {
    return (
      <span>
        {isLandingPage && <h5><b>Internal Use Only</b></h5>}
        <span>Insurance products are sold through Covr Financial Technologies Inc ("Covr"). Covr sells insurance as an agent or broker by contractual agreements with its insurance carrier providers. Covr is licensed in the following states: Delaware (3000067942), Idaho (607086), California (0L77229). All other state license numbers are available on our <Button variant="text" className={`${isLandingPage && 'link-color'}`} onClick={() => onButtonClick(links.StateLicense)}>State License Disclosure Page</Button>.
        </span>
      </span>
    )
  }

  return (
    <footer className={`footer py-3 flex-fill ${expanded ? "sidebar-open" : "sidebar-close"}`}>
      <Container fluid>
        <Col lg={12} className="">
          <Row className="justify-content-center">
            <Col lg={isLandingPage ? 11 : 6}>
              {getDisclaimers()}
            </Col>
          </Row>
          <Row className={`justify-content-center my-4 links`}>
            {!isLandingPage &&
            <Col xs={12} sm className="d-flex align-items-center justify-content-center">
              <Button variant="text" onClick={() => onButtonClick(links.Terms)}>Terms &#38; Conditions</Button>
            </Col>
            }
            <Col xs={12} sm lg={isLandingPage && 3} className={`d-flex align-items-center justify-content-center ${isLandingPage && 'pr-0'}`}>
              <Button variant="text" className={`${isLandingPage && 'link-color'}`} onClick={() => onButtonClick(links.Security)}>Security &#38; Privacy Policy</Button>
            </Col>
            <Col xs={12} sm lg={isLandingPage && 2} className="d-flex align-items-center justify-content-center">
              <Button variant="text" className={`${isLandingPage && 'link-color'}`} onClick={() => onButtonClick(links.AccessibiltyPolicy)}>Accessibility Policy</Button>
            </Col>
            {!isLandingPage &&
            <React.Fragment>
            <Col xs={12} sm className="d-flex align-items-center justify-content-center">
              <Button variant="text" onClick={() => onButtonClick(links.Contact)}>Contact Us</Button>
            </Col>
            <Col xs={12} sm className="d-flex align-items-center justify-content-center">
              <span>Account ID: {accountId}</span>
            </Col>
            </React.Fragment>
            }
            {isLandingPage &&
             <Col xs={12} sm lg={isLandingPage && 2} className="d-flex align-items-center justify-content-center">
              <span>Copyright &copy; {year}</span>
            </Col>
            }
          </Row>
          <Row className="justify-content-center"><strong>Powered by</strong></Row>
          <Row className="justify-content-center">
            <img src={process.env.PUBLIC_URL + '/logos/covr-logo.svg'} alt="Covr Logo" />
          </Row>
          <Row className="justify-content-center covr">Covr Financial Technologies</Row>
          <Row className="justify-content-center">Hartford. Boise. Colorado Springs.</Row>
          {!isLandingPage && <Row className="justify-content-center">Copyright &copy; {year}</Row>}
        </Col>

        <FooterModalPopup
          open={infoDialogOpen}
          onInfoDialogClosed={() => {
            setInfoDialogOpen(false);
          }}
          component={renderComponent}
        >
        </FooterModalPopup>

      </Container>
    </footer>
  )
}

function FooterModalPopup(props) {
  return (
    <Dialog open={props.open} onClose={props.onInfoDialogClosed} scroll="body" maxWidth='md'>
      <DialogContent className="product-info-dialog-content-footer">
        <IconButton className="product-info-close-button" aria-label="close" onClick={props.onInfoDialogClosed}>
          <CloseIcon />
        </IconButton>
        {props.component}
      </DialogContent>
    </Dialog>
  )
}





// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js